// extracted by mini-css-extract-plugin
module.exports = {"header":"CheckoutHeader_header__3N0N9","logo":"CheckoutHeader_logo__DdVrH","organization":"CheckoutHeader_organization__T92Ps"};